import script from "./EditOrderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditOrderView.vue?vue&type=script&setup=true&lang=ts"

import "./EditOrderView.vue?vue&type=style&index=0&id=4da6213a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da6213a"]])

export default __exports__